<template>
  <ProductDisplay
    v-if="hasProductRecommendations"
    :title="heading"
    color="white"
  >
    <Carousel :inline="inline">
      <ProductQueryWrapper
        v-for="(recommendation, index) in recommendations"
        :key="recommendation.id"
        v-slot="{ product }"
        :product-id="recommendation.product_id"
      >
        <ProductCardHelper
          v-if="product"
          v-slot="{ primaryMedia, secondaryMedia }"
          :product="product"
          :image-type="getImageType(index)"
        >
          <ProductCard
            :media="primaryMedia"
            :hover-media="secondaryMedia"
            :product="productWithReferralPlacement(product)"
          />
        </ProductCardHelper>
      </ProductQueryWrapper>
    </Carousel>
  </ProductDisplay>
</template>

<script>
import ProductDisplay from "@/components/product-display/ProductDisplay.vue";
import ProductCard from "@/components/ProductCard.vue";
import ProductCardHelper from "@/components/product-card/ProductCardHelper.vue";
import Carousel from "@/components/Carousel.vue";
import ProductQueryWrapper from "@/components/ProductQueryWrapper.vue";
import { reccsImageSequence } from "@/helpers/imageSequences.js";

export default {
  name: "NostoProductRecommendationsV2",
  components: {
    ProductCard,
    ProductQueryWrapper,
    Carousel,
    ProductDisplay,
    ProductCardHelper,
  },
  props: {
    recommendations: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      required: true,
    },
    placement: {
      type: String,
      default: null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    imageSequence: {
      type: Array,
      default: () => reccsImageSequence,
    },
  },
  computed: {
    hasProductRecommendations() {
      return this.recommendations?.length >= 1;
    },
  },
  methods: {
    getImageType(index) {
      return this.imageSequence[index % this.imageSequence.length];
    },
    productWithReferralPlacement(product) {
      if (!this.placement) {
        return product;
      }

      const newOnlineStoreUrl = new URL(product.onlineStoreUrl);
      newOnlineStoreUrl.searchParams.set("ref-placement", this.placement);

      return {
        ...product,
        onlineStoreUrl: newOnlineStoreUrl,
      };
    },
  },
};
</script>
